import { Column, Entity, Index, JoinColumn, ManyToOne } from 'typeorm';
import { BaseEntity } from './base.entity';
import { EmailSourceEntity } from './email-source.entity';

@Entity('email_sync_subscription')
@Index(['subscriptionId'], { unique: true })
@Index(['emailSourceId'])
@Index(['expirationDate'])
export class EmailSyncSubscriptionEntity extends BaseEntity {
	// Using standard INT id from BaseEntity - no override needed

	@Column({ name: 'fk_email_source__id', type: 'int', unsigned: true })
	public emailSourceId!: number;

	@ManyToOne(() => EmailSourceEntity, (source) => source.subscriptions)
	@JoinColumn({ name: 'fk_email_source__id' })
	public emailSource!: EmailSourceEntity;

	@Column({ name: 'subscription_id', type: 'varchar', length: 255 })
	public subscriptionId!: string;

	@Column({ type: 'varchar', length: 255 })
	public resource!: string;

	@Column({ name: 'change_type', type: 'varchar', length: 100 })
	public changeType!: string;

	@Column({ name: 'notification_url', type: 'varchar', length: 500 })
	public notificationUrl!: string;

	@Column({ name: 'expiration_date', type: 'timestamp' })
	public expirationDate!: Date;

	@Column({
		name: 'client_state',
		type: 'varchar',
		length: 255,
		nullable: true,
	})
	public clientState?: string;
}
